import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
export { isValidEmail, isValidMobileLandNumber, isValidMobileNumber, isValidAlphaWithSpace, isValidAlphaNumericNoSpace, isValidNric } from './validations';
export { getAllCookies, getCookie, getJsonCookie, setCookie, setJsonCookie } from './cookie';
export { serializeObject } from './network';
export function remCalc(px) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  var forcePortable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (typeof __PORTABLE_LUX__ !== 'undefined' && __PORTABLE_LUX__ || forcePortable) {
    return px + 'px';
  } else {
    return px / base + 'rem';
  }
}
export function hexToRGBA(hex) {
  var _hex = hex.replace('#', '');
  return {
    r: parseInt(_hex.slice(0, 2), 16),
    g: parseInt(_hex.slice(2, 4), 16),
    b: parseInt(_hex.slice(4, 6), 16),
    a: parseInt(_hex.slice(6, 8).length === 0 ? 'FF' : _hex.slice(6, 8), 16)
  };
}
export function rgbaToHex(rgba, withHash) {
  var hex = [Number(rgba.r).toString(16), Number(rgba.g).toString(16), Number(rgba.b).toString(16), Number(rgba.a).toString(16)].map(function (item) {
    return item.length === 1 ? '0' + item : item;
  });
  return (withHash ? '#' : '') + hex.join('').toUpperCase();
}
export function adjustContrast(colour, amount) {
  var r = parseInt(colour.r + colour.r / 100 * (1 + amount));
  var g = parseInt(colour.g + colour.g / 100 * (1 + amount));
  var b = parseInt(colour.b + colour.b / 100 * (1 + amount));
  return {
    r: r < 256 ? r : 255,
    g: g < 256 ? g : 255,
    b: b < 256 ? b : 255,
    a: colour.a
  };
}
export function getUrlParams() {
  var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
  var hashes = /[?&]/.test(searchString) ? searchString.slice(searchString.indexOf('?') + 1).split('&') : [];
  return hashes.filter(function (hash) {
    return hash;
  }).reduce(function (accum, hash) {
    var _hash$split = hash.split('='),
      _hash$split2 = _slicedToArray(_hash$split, 2),
      key = _hash$split2[0],
      val = _hash$split2[1];
    accum[key] = val && decodeURIComponent(val) || '';
    return accum;
  }, {});
}
export function setUrlParams(url, params) {
  var urlWithoutHash = url.split('#')[0];
  var urlHash = url.split('#')[1];
  var paramsWithExisting = Object.assign(getUrlParams(urlWithoutHash), params);
  var newParams = Object.keys(paramsWithExisting).map(function (key) {
    return [key, paramsWithExisting[key]].map(encodeURIComponent).join('=');
  }).join('&');
  var hashString = urlHash ? "#".concat(urlHash) : '';
  var urlQueryString = newParams ? [urlWithoutHash.split('?')[0], newParams].join('?') : urlWithoutHash.split('?')[0];
  return urlQueryString + hashString;
}
export function isEnterKey(e) {
  return e.which === 13 || e.keyCode === 13 || e.key === 13;
}
export function isEscapeKey(e) {
  return e.key === 'Escape' || e.key === 'Esc';
}
export function isUrlAbsolute(url) {
  return url.indexOf('://') > 0 || url.indexOf('//') === 0;
}
export function debounce(func) {
  var _arguments = arguments,
    _this = this;
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var debounceFunc;
  return function () {
    var context = _this;
    var args = _arguments;
    clearTimeout(debounceFunc);
    debounceFunc = setTimeout(function () {
      return func.apply(context, args);
    }, delay);
  };
}
export function noop() {}